import { Component } from '@opten/compiler/metadata/component';
import { MenuMultiLevel } from '@opten/menu-multilevel';

@Component({ className: 'js-menu-multilevel' })
export class MenuMultilevelComponent {

	constructor(private element: HTMLElement) {

		const backLabel = element.attributes.getNamedItem('data-back-label').value;

		const multiLevelMenu = new MenuMultiLevel(element, {
			backLabel,
			resetOnClose: false,
		});
	}
}